import React from "react";

/**
 * Top-level safety net. If anything below it throws during render or in a
 * lifecycle/effect, React unmounts that subtree — without a boundary that means
 * a blank white page. This catches it and shows a calm, friendly card with a
 * Refresh button instead, so a transient error or a slow/waking server never
 * looks like "the site is broken" to a family member.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught an error:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f8f5eb",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: "460px",
            textAlign: "center",
            background: "#ffffff",
            border: "1px solid #e4dfd2",
            borderRadius: "14px",
            padding: "32px 28px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          }}
        >
          <div style={{ fontSize: "44px", marginBottom: "10px" }}>🌿</div>
          <h1
            style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              color: "#1f2a44",
              fontSize: "24px",
              margin: "0 0 10px",
            }}
          >
            Just a moment
          </h1>
          <p style={{ color: "#444", fontSize: "16px", lineHeight: 1.55, margin: "0 0 22px" }}>
            Something hiccupped on our end — the family server may be waking up.
            Your information is safe. Please refresh to try again.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: "#1f2a44",
              color: "#ffffff",
              border: "none",
              borderRadius: "10px",
              padding: "12px 26px",
              fontSize: "16px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Refresh the page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
